import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import FcmNotification from 'eop-ui-core/models/FcmNotification'
import { CustomEventType } from '@/constants/enum/CustomEventType'
import { FIREBASE_API_KEY, FIREBASE_APP_ID, FIREBASE_MESSAGING_SENDER_ID, FIREBASE_PROJECT_ID, FIREBASE_VAPID } from '@/constants/env'

if ('serviceWorker' in navigator && process.env.NODE_ENV !== 'development') {
  initializeApp({
    apiKey: FIREBASE_API_KEY,
    authDomain: `${FIREBASE_PROJECT_ID}.firebaseapp.com`,
    projectId: FIREBASE_PROJECT_ID,
    storageBucket: `${FIREBASE_PROJECT_ID}.appspot.com`,
    messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
    appId: FIREBASE_APP_ID,
  })
  const messaging = getMessaging()
  getToken(messaging, { vapidKey: FIREBASE_VAPID })
    .then((token) => {
      console.info('fcmToken', token)
      const storedToken = localStorage.getItem('fcmToken')
      if (storedToken !== token) {
        localStorage.setItem('fcmToken', token)
        window.dispatchEvent(new CustomEvent(CustomEventType.FcmTokenStored, { detail: { token } }))
      }
    })
    .catch(console.error)

  onMessage(messaging, (payload) => {
    if (payload.data?.channel !== 'PortalWeb') {
      return
    }
    window.dispatchEvent(new CustomEvent(CustomEventType.FcmMessageReceived, { detail: new FcmNotification(payload.data) }))
  })
}
